// angular
import { NgClass, NgOptimizedImage } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
// types
import { PreviewMenuOptionsType } from '@app/+products/shared/types/product-preview.type';

@Component({
  selector: 'pwj-options-menu',
  standalone: true,
  imports: [TranslateModule, NgClass, NgOptimizedImage],
  templateUrl: './options-menu.component.html',
  styleUrl: './options-menu.component.scss',
})
export class OptionsMenuComponent {
  public pageLink!: string;

  // inputs
  menuOptions = input.required<PreviewMenuOptionsType[]>();
  isRowMode = input<boolean>();

  constructor() {
    this.pageLink = window.location.href;
  }
}
